import React from 'react';
import PropTypes from 'prop-types';

const LogoBottom = ({ size, fill, altFill }) => (
  <svg viewBox="0 0 116.2 183.35" width={size}>
    <path
      fill={fill}
      d="M240.77,189.51h-3.6a2.61,2.61,0,0,0-2.56,2.92V241.3c0,1.41,1,2.56,3.62,2.56h1.48c2.65,0,3.62-1.15,3.62-2.56V192.43A2.61,2.61,0,0,0,240.77,189.51Z"
      transform="translate(-157.9 -60.51)"
    />
    <path
      fill={fill}
      d="M181,202.59c-5.6.08-8.8,2.12-10.89,5.26V192.43a2.61,2.61,0,0,0-2.56-2.92h-3.6a2.61,2.61,0,0,0-2.56,2.92V241.3c0,1.41,1,2.56,3.62,2.56h1.48c2.65,0,3.62-1.15,3.62-2.56V214.79c.91-1.36,3.68-4.83,7.89-4.33,5.21.62,6.36,3.35,6.36,6.18V241.3c0,1.41,1,2.56,3.63,2.56h1.48c2.65,0,3.62-1.15,3.62-2.56V213.73C193.05,211.16,192.37,203.12,181,202.59Z"
      transform="translate(-157.9 -60.51)"
    />
    <path
      fill={fill}
      d="M198.42,228.53V218a15.33,15.33,0,0,1,15.33-15.33h0A15.33,15.33,0,0,1,229.08,218h0v10.52h0a15.33,15.33,0,0,1-15.33,15.33h0a15.33,15.33,0,0,1-15.33-15.33ZM206.9,218v10.52a6.87,6.87,0,0,0,6.85,6.85h0a6.87,6.87,0,0,0,6.85-6.85h0V218a6.87,6.87,0,0,0-6.85-6.85h0A6.87,6.87,0,0,0,206.9,218Z"
      transform="translate(-157.9 -60.51)"
    />
    <path
      fill={fill}
      d="M270.34,205.39c-3.13-3.3-5.25-3.06-7-2.18a34.4,34.4,0,0,0-5.15,4.07v-1.6a2.61,2.61,0,0,0-2.56-2.91H252a2.61,2.61,0,0,0-2.57,2.91V241.3c0,1.41,1,2.56,3.63,2.56h1.48c2.65,0,3.62-1.15,3.62-2.56V214.46c3.92-4.07,5.91-4.22,7.15-3.89s2.53,1.83,3.36.71S271.4,206.69,270.34,205.39Z"
      transform="translate(-157.9 -60.51)"
    />
    <path
      fill={fill}
      d="M189.44,75.87S184,71.7,179.29,73l.73,1.27s-10,2-12.51,10.33l2.9-.54s-4.53,10.15-11.6,9.78c.54,2.9,4.35,6,4.35,6s-4,5.07-.54,13.77c-2.72,4.53-3.81,7.8-3.45,14.87s-.72,10.33-1.27,11.24a5.65,5.65,0,0,0,2-.55,8.83,8.83,0,0,1-1.27,4.53,24.33,24.33,0,0,0,8.34-1.27c-.19,4.36,1.81,10.7,7.43,13.78.54,2,1.09,5.62.54,6.71,3.08.72,3.45-.18,3.45-.18A34.86,34.86,0,0,1,180.92,173a7.41,7.41,0,0,0,3.08-2.18,62.49,62.49,0,0,1,.19,7.07c6-3.44,6.89-5.62,7.79-7.25.91,4.17,2.18,11.24,12.15,14.5,6,5.62,11.23,7.44,12.68,9.25l.55-1.81s7.43-4.53,11.06-8.16l-.18,1.81s10.51-5.62,11.23-16.49c0,0,3.45,6.16,8.71,6.88a32.81,32.81,0,0,1,.72-5.8s2.18,3.09,2.54,3.63c0-4.9,2.54-11.78,2.54-11.78a11.82,11.82,0,0,0,1.63,3.26c-.18-4,3.8-9.24,5.07-12.69l-.72,2.9s6.16-7.25,5.07-14.5c1.82,1.63,6.17,1.45,9.07-.73-1.27-1.26-2.72-2.71-3.08-3.8a25.52,25.52,0,0,0,2.35,1.81,66.9,66.9,0,0,1,.18-10.51c.55-6.71-.9-13.06-6.7-17.4,2.9-1.82,3.8-6.17,1.45-10.88,1.63.54,3.08-1.63,4.16-3.81-1.81-.9-4.53-2.17-11.6-7.25s-11.24-6.34-14.5-6.71c-2.54-4-5.62-4.53-7.07-5.25a4.66,4.66,0,0,1,4.72,0s-1.63-8.34-14-10.15c.54-.73,3.44-1.82,3.44-1.82s-11.6-4-16,4.54c-1.81-1.64-1.63-5.8,3.63-6.71-6.89-4-19.94-3.63-22.3,4.35-1.63-1.09-1.81-3.63-1.81-3.63S188.54,69.71,189.44,75.87Z"
      transform="translate(-157.9 -60.51)"
    />
    <path
      fill={altFill}
      d="M199.21,87.47s-17.58,3.08-3.08-17.22c.18,2.54,6,13.59,8.88,15,0,0-6.52-.72-9.24-5.62C195.77,79.67,194.68,83.66,199.21,87.47Z"
      transform="translate(-157.9 -60.51)"
    />
    <path
      fill={altFill}
      d="M210.27,84.93a14,14,0,0,1-10-9.61c-2.54-8.15,8.52-12.14,13.41-11C206.64,64.27,198.85,73.69,210.27,84.93Z"
      transform="translate(-157.9 -60.51)"
    />
    <path
      fill={altFill}
      d="M237.46,89.64s2,.91,6.52,7.07,6.17,9.25,10.34,10l-.91-1.27a19.14,19.14,0,0,0,5.8,1.64c-1.63-1.09-2.72-2.54-5.07-6.71s-3.45-6.89-10.88-9.61a3.77,3.77,0,0,1,2,2.9S241.63,90,237.46,89.64Z"
      transform="translate(-157.9 -60.51)"
    />
    <path
      fill={altFill}
      d="M232.93,87.65s9.24-2.54,20.3,6,13.41,13.6,13.41,13.6,2.9-6.35-8.7-13c4.17,1.81,8,4.89,10.15,2.53-6.34-2.35-16.13-10-23.74-11.78S232.93,87.65,232.93,87.65Z"
      transform="translate(-157.9 -60.51)"
    />
    <path
      fill={altFill}
      d="M227.85,85.11s6.53-4.17,13.6-2.9c-8.34-4.71-18.31-2.54-19.76,3.27,5.07-4,9.79-3.63,9.79-3.63A34.3,34.3,0,0,0,227.85,85.11Z"
      transform="translate(-157.9 -60.51)"
    />
    <path
      fill={altFill}
      d="M213.89,85.84s3.45-9.61-1.81-17.59c-2.54.37-4,5.81-1.45,11.42S213.89,85.84,213.89,85.84Z"
      transform="translate(-157.9 -60.51)"
    />
    <path
      fill={altFill}
      d="M218.06,85.84s-2.17-15.23,7.62-19.94a19.43,19.43,0,0,0-2.9,6.52c3.62-4.17,11.78-3.44,16.67,1.27C228.21,71.16,221.69,77.68,218.06,85.84Z"
      transform="translate(-157.9 -60.51)"
    />
    <path
      fill={altFill}
      d="M188.88,79l-1.27,4.53s-1.63-2.36-6-1.09a1.43,1.43,0,0,1,.72,1.45s-4.53-.9-6.16,2.54a7.72,7.72,0,0,1,3.81,0s-4.17,2-4.54,4.9a12.15,12.15,0,0,1-.36-8.7,14.89,14.89,0,0,0-2.35-.37,18.86,18.86,0,0,1,9.78-4.35V76.77A19.3,19.3,0,0,1,188.88,79Z"
      transform="translate(-157.9 -60.51)"
    />
    <path
      fill={altFill}
      d="M194.23,89.46A47.56,47.56,0,0,0,187,97.71c-3.35,4.71-4.35,8.25-8.7,8.61a14.16,14.16,0,0,1,.82-1.54c-3.54,2.36-4.71,2.36-5.89,2.45,3.71-2.54,4.59-9.22,9.33-12.87a23.6,23.6,0,0,1,6.35-3.63s-2.27,1.72-2.27,3.08A26.52,26.52,0,0,1,194.23,89.46Z"
      transform="translate(-157.9 -60.51)"
    />
    <path
      fill={altFill}
      d="M172.25,93.32s.22,1.45-3.85,5.21-3.4,6.57-3,9.38a13.51,13.51,0,0,1,4.8-6.44c3-2.31,3.85-4,3.67-5.89a6.83,6.83,0,0,1-2.35,2.58S173,95.31,172.25,93.32Z"
      transform="translate(-157.9 -60.51)"
    />
    <path
      fill={altFill}
      d="M170.71,93.18a9,9,0,0,1-6.26,2.9C165.9,98,168.76,98.12,170.71,93.18Z"
      transform="translate(-157.9 -60.51)"
    />
    <path
      fill={altFill}
      d="M175.15,110s-7.8,3.49-9.52,10.24c-1.72,6.44-1,10.65-3.22,13.15.73-1.95.5-4.54.59-9.79S165,112.21,175.15,110Z"
      transform="translate(-157.9 -60.51)"
    />
    <path
      fill={altFill}
      d="M185.21,109.9s-9.84.72-14.91,8.34c-3.9,5.85-1.22,10.38-6.93,21.39,3.12.5,6.38-4.67,6.84-5.66-.37,6.34.72,13.23,2.72,17.22,0,0-.18-7.16.63-10.15a52,52,0,0,0,2.27,10.51c1.72,4.89,2,6.16,1.81,8.25a8.2,8.2,0,0,0,1.9-4.72s2,3.54,2.81,12.6c2-2,2.54-8.88,2.54-8.88a19.47,19.47,0,0,1,.73,9.15c1.17-.18,1.26-1,1.26-1a13.36,13.36,0,0,1-.54,5.43c3.54-4.62,6.71-6.61,5.8-15.49s-3.53-12.15-2.36-19.49a14.9,14.9,0,0,0-2.35,4.08,22.77,22.77,0,0,1,0-11.51c-2.45,1.81-4.26,6.43-4.26,6.43a17.7,17.7,0,0,1,1.27-9.6c-2.63,1.26-5.17,5.07-5.44,7.07-.64-3.72,1-10.16,3.9-13.15-2.09.64-4.63,3-5.35,3.81.27-2,3.26-6.34,4.44-7.16a16.4,16.4,0,0,0-8.25,4.8C174.47,119.46,179.09,112.66,185.21,109.9Z"
      transform="translate(-157.9 -60.51)"
    />
    <path
      fill={altFill}
      d="M195.13,148.29s2.54,2,2.27,9.51.45,8,.45,8a11.46,11.46,0,0,1,2.45-3.63c-1.81,3.45-1.81,14.32,1.18,19.13-3.9-3-6.35-10.06-6.17-15.59S195.68,151.82,195.13,148.29Z"
      transform="translate(-157.9 -60.51)"
    />
    <path
      fill={altFill}
      d="M257,110s7.8,3.49,9.52,10.24c1.72,6.44,1,10.65,3.21,13.15-.72-1.95-.49-4.54-.59-9.79S267.1,112.21,257,110Z"
      transform="translate(-157.9 -60.51)"
    />
    <path
      fill={altFill}
      d="M246.93,109.9s9.83.72,14.91,8.34c3.9,5.85,1.22,10.38,6.93,21.39-3.12.5-6.39-4.67-6.84-5.66.36,6.34-.72,13.23-2.72,17.22,0,0,.18-7.16-.63-10.15a52,52,0,0,1-2.27,10.51c-1.72,4.89-2,6.16-1.81,8.25a8.2,8.2,0,0,1-1.9-4.72s-2,3.54-2.81,12.6c-2-2-2.54-8.88-2.54-8.88a19.47,19.47,0,0,0-.73,9.15c-1.18-.18-1.27-1-1.27-1a13.46,13.46,0,0,0,.55,5.43c-3.54-4.62-6.71-6.61-5.8-15.49s3.53-12.15,2.35-19.49a14.74,14.74,0,0,1,2.36,4.08,22.77,22.77,0,0,0,0-11.51c2.45,1.81,4.26,6.43,4.26,6.43a17.7,17.7,0,0,0-1.27-9.6c2.63,1.26,5.17,5.07,5.44,7.07.63-3.72-1-10.16-3.9-13.15,2.09.64,4.62,3,5.35,3.81-.27-2-3.26-6.34-4.44-7.16a16.32,16.32,0,0,1,8.24,4.8C257.67,119.46,253.05,112.66,246.93,109.9Z"
      transform="translate(-157.9 -60.51)"
    />
    <path
      fill={altFill}
      d="M237,148.29s-2.54,2-2.27,9.51-.45,8-.45,8a11.46,11.46,0,0,0-2.45-3.63c1.81,3.45,1.81,14.32-1.18,19.13,3.9-3,6.35-10.06,6.16-15.59S236.46,151.82,237,148.29Z"
      transform="translate(-157.9 -60.51)"
    />
    <path
      fill={altFill}
      d="M204,172.39a18.5,18.5,0,0,0,5.56,11.33c-.62-2.1-.68-5,.4-6.52-.06,3.6,1.77,9.38,3.47,11.35-3.6-3.26-8.16-7.27-9.31-9.65S204,172.39,204,172.39Z"
      transform="translate(-157.9 -60.51)"
    />
    <path
      fill={altFill}
      d="M218.47,188.69a44.19,44.19,0,0,0,2.92-6.26,19.83,19.83,0,0,0,.89-5s.81,2,.41,6.12a18.77,18.77,0,0,0,5.3-11c.74,2.92.47,6.66-1.5,8.9S221.94,185.7,218.47,188.69Z"
      transform="translate(-157.9 -60.51)"
    />
    <path
      fill={altFill}
      d="M198.09,107a3.57,3.57,0,0,0,2.4,2.77c1.41.45,3.36-.28,3.76-1.45a4.14,4.14,0,0,0-1.67-.23,1.28,1.28,0,0,1-1.36.54A1.36,1.36,0,0,1,200,107,11,11,0,0,0,198.09,107Zm32.83,1.63a1.28,1.28,0,0,1-1.36-.54,4.2,4.2,0,0,0-1.68.23c.41,1.17,2.36,1.9,3.76,1.45A3.55,3.55,0,0,0,234,107a10.82,10.82,0,0,0-1.85,0A1.36,1.36,0,0,1,230.92,108.63ZM241.23,112c-3.47-3.2-4.49-3.67-5.51-2.45s-2.78,1.63-4.89,1.56-3.94-.4-3.67-.13c.75.61,1.43,4.08,1.22,4.83,1.84-.34,2.65,0,3.13.74a8,8,0,0,0-4.15,1.43c-.2.14-.61-.07-.61-1.43s-.34-4.48-2-5.16c.07.54-.34,1.08-.61.81s.06-1.42-1.77-2.78-3.16-2.25-3.6-3.37-.21-2.34.54-2.28c.65.45,2.45,3.33,5.74,3.61s6.87-2.55,9-3.64,4.93-1.26,6.26.31c-1.09.91-2.48,2-2.48,2.27s0,.85,1.43.85a3.28,3.28,0,0,0,3.33-1.63c.91-1.46.74-3.77-1.84-6.39s-4.72-4.69-8.5-8.36-7.1-4.72-10.46-3.64c-2.85.92-4.11,2.93-5.79,3.1-1.68-.17-2.95-2.18-5.79-3.1-3.36-1.08-6.69,0-10.47,3.64s-5.91,5.74-8.49,8.36-2.76,4.93-1.84,6.39a3.27,3.27,0,0,0,3.33,1.63c1.43,0,1.43-.41,1.43-.85s-1.39-1.36-2.48-2.27c1.32-1.57,4.08-1.4,6.25-.31s5.75,3.91,9,3.64,5.1-3.16,5.75-3.61c.74-.06,1,1.16.54,2.28s-1.77,2-3.6,3.37-1.5,2.51-1.77,2.78-.68-.27-.61-.81c-1.63.68-2,3.8-2,5.16s-.41,1.57-.61,1.43a8,8,0,0,0-4.15-1.43c.48-.74,1.29-1.08,3.13-.74-.21-.75.47-4.22,1.22-4.83.27-.27-1.56.07-3.67.13s-3.88-.33-4.9-1.56-2-.75-5.5,2.45-3.81,6.86-2.45,8.77a32.49,32.49,0,0,0,4.22,4.35,5,5,0,0,1,.4-3.4c.89-1.9,1.23-2.72.89-3.47s-.48-2.44.34-3.06c2.17,3.47,3.06,3.67,5,4.22-3.47,2-3.54,4.48-3.54,4.48a58.12,58.12,0,0,1,6.8,2c-2.85,0-6.73-.47-6.73-.47s0,2.58.48,3,3.33,1.29,9.11,3.19c-3.13-.06-8.77-.27-8.77-.27a4.77,4.77,0,0,0,.88,1.09c.68.68,3.81,1,9.52,2.38-1.91,1.29-5.92.75-8.36.75,5.71,6.93,13.73,2.44,14.81.54s1-4.21-2-5.71-6.94-3-7.21-4.21a9.92,9.92,0,0,1,.27-3.4s1,2.44,3,1.63,2.45-2.58,4.9-2a26.85,26.85,0,0,0,7.22,0c2.45-.54,2.86,1.22,4.89,2s3-1.63,3-1.63a9.92,9.92,0,0,1,.27,3.4c-.27,1.22-4.22,2.71-7.21,4.21s-3.12,3.81-2,5.71,9.11,6.39,14.82-.54c-2.45,0-6.46.54-8.36-.75,5.71-1.36,8.84-1.7,9.52-2.38a4.77,4.77,0,0,0,.88-1.09s-5.64.21-8.77.27c5.78-1.9,8.63-2.78,9.11-3.19s.48-3,.48-3-3.88.47-6.73.47a58.26,58.26,0,0,1,6.79-2s-.06-2.51-3.53-4.48c2-.55,2.85-.75,5-4.22.82.62.68,2.31.34,3.06s0,1.57.88,3.47a5,5,0,0,1,.41,3.4,32.49,32.49,0,0,0,4.22-4.35C245,118.87,244.7,115.2,241.23,112Zm-17.29-11.22c.32-.5,3.14-3.62,6.52-4.17,2.54-.4,3.31,1.36,2.77,1.27-4.49-.41-8.84,3.31-8.84,3.31C224.17,101.29,223.71,101.25,223.94,100.79Zm-16.2.41s-4.35-3.72-8.83-3.31c-.55.09.22-1.67,2.76-1.27,3.39.55,6.21,3.67,6.53,4.17S208,101.29,207.74,101.2Zm5.53,9.74c0-.81.74-1.34,1.62-1.61a3.28,3.28,0,0,1,2.76.14,1.7,1.7,0,0,1,1.22,1.47A27,27,0,0,0,213.27,110.94Z"
      transform="translate(-157.9 -60.51)"
    />
    <path
      fill={altFill}
      d="M209,125.33a4.72,4.72,0,0,1,2.79.21,11.73,11.73,0,0,0,4.35,1.19v-1.84a8.48,8.48,0,0,1-2.72-.44C211.71,124,210.16,124,209,125.33Z"
      transform="translate(-157.9 -60.51)"
    />
    <path
      fill={altFill}
      d="M223.14,125.33a4.72,4.72,0,0,0-2.79.21,11.79,11.79,0,0,1-4.35,1.19v-1.84a8.48,8.48,0,0,0,2.72-.44C220.43,124,222,124,223.14,125.33Z"
      transform="translate(-157.9 -60.51)"
    />
    <path
      fill={altFill}
      d="M210.85,139.49a3,3,0,0,0,.41,3.13,3.56,3.56,0,0,1,.55-1.5s2.44-.08,5.71,0v-1.86A28.09,28.09,0,0,0,210.85,139.49Z"
      transform="translate(-157.9 -60.51)"
    />
    <path
      fill={altFill}
      d="M221.28,139.49a3,3,0,0,1-.4,3.13,3.56,3.56,0,0,0-.55-1.5s-2.45-.08-5.71,0v-1.86A28,28,0,0,1,221.28,139.49Z"
      transform="translate(-157.9 -60.51)"
    />
    <path
      fill={altFill}
      d="M204.29,140.54s2.22-.09,2.58.36a15.65,15.65,0,0,0,1.45,5.62C206.15,146.2,203.34,142.39,204.29,140.54Z"
      transform="translate(-157.9 -60.51)"
    />
    <path
      fill={altFill}
      d="M227.85,140.54s-2.22-.09-2.59.36a15.24,15.24,0,0,1-1.45,5.62C226,146.2,228.8,142.39,227.85,140.54Z"
      transform="translate(-157.9 -60.51)"
    />
    <path
      fill={altFill}
      d="M209.92,155.24a5.32,5.32,0,0,1-2.38,1.22c-1.15.14-1.9-1.15-1.56-5.84A16.77,16.77,0,0,0,209.92,155.24Z"
      transform="translate(-157.9 -60.51)"
    />
    <path
      fill={altFill}
      d="M222.21,155.24a5.39,5.39,0,0,0,2.38,1.22c1.16.14,1.91-1.15,1.57-5.84A16.64,16.64,0,0,1,222.21,155.24Z"
      transform="translate(-157.9 -60.51)"
    />
    <path
      fill={altFill}
      d="M210.67,155.07a11.52,11.52,0,0,0,1.57-.1c-.05-.82-.31-1.29-1-1.23S210.67,154.8,210.67,155.07Z"
      transform="translate(-157.9 -60.51)"
    />
    <path
      fill={altFill}
      d="M219.87,155.07a11.52,11.52,0,0,0,1.57-.1c-.05-.82-.31-1.29-.94-1.23S219.87,154.8,219.87,155.07Z"
      transform="translate(-157.9 -60.51)"
    />
    <path
      fill={altFill}
      d="M212.91,154.94H214s.15-.92-.51-.92S212.88,154.56,212.91,154.94Z"
      transform="translate(-157.9 -60.51)"
    />
    <path
      fill={altFill}
      d="M214.48,154.94h1.09s.13-.88-.51-.92S214.44,154.56,214.48,154.94Z"
      transform="translate(-157.9 -60.51)"
    />
    <path
      fill={altFill}
      d="M216.71,154.94h1.09s.15-.92-.51-.92S216.68,154.56,216.71,154.94Z"
      transform="translate(-157.9 -60.51)"
    />
    <path
      fill={altFill}
      d="M218.27,154.94h1.09s.14-.88-.51-.92S218.24,154.56,218.27,154.94Z"
      transform="translate(-157.9 -60.51)"
    />
    <path
      fill={altFill}
      d="M204.06,159s-.22,1.63,1.95,1.77,3.44-.86,5.89-2a8.3,8.3,0,0,1,6.62-.73c2.54.68,6.39,3.18,8.38,2.77s1.31-1.68,1.31-1.68.5-.45.69.36a12.46,12.46,0,0,1-1,6.85,8.17,8.17,0,0,1-5.13,4,2.29,2.29,0,0,0-.45-1.18,9.49,9.49,0,0,1-6,3.26A8.28,8.28,0,0,1,210,169c-.5.18-.46,1-.41,1.13-1.4.37-4.53-1.13-5.75-4.66a11.78,11.78,0,0,1-.46-6.53C203.61,158.3,204.06,158.39,204.06,159Z"
      transform="translate(-157.9 -60.51)"
    />
    <path
      fill={fill}
      d="M235.28,109.11l11.7,0a2.25,2.25,0,0,1,2.33,2.51c1.54.09,2.73.15,1.21,3.48-1.05,2.11-2.12,1.93-3.31,2.17-4.16,8.35-6.75,12.52-11.65,12.62C226.66,115.4,235.28,109.11,235.28,109.11Z"
      transform="translate(-157.9 -60.51)"
    />
    <path
      fill={fill}
      d="M194.51,129.59c-3.95.17-7.48-6.62-10-12.56-2.15-.23-2.91-1.19-3.48-3.13-.69-2.34.25-2.91,1.71-2.8-.47-1.41.57-1.91,1.49-1.88s10.93,0,10.93,0h3.34c1,0,1.53,1,2.58,1s2.81-1,3.75-1h1.34c2.91,0,3.75.43,5.5,1.68s2.83,2.42,4.66,2.34c1.67-.09,4.09-3.92,6.51-3.92h4.66l7.09,20.92a43.8,43.8,0,0,0-5.42.25c-4,.33-8,0-9.58-3.09s-1.84-8.91-3.17-9.33-1.59,1.33-2.25,3.83-2.75,8.25-8.75,8.17-10.5-.58-10.5-.58l-.36.1"
      transform="translate(-157.9 -60.51)"
    />
    <path
      fill={altFill}
      d="M185.47,110.23s20.29,0,22.87.16,3.84,1.39,5.24,2.37a4.09,4.09,0,0,0,3.38.78l.37,3.32a2.77,2.77,0,0,0-3.89,2.29c-.64,3.55-1.85,10.39-6.92,10.89-6.56.66-12.09,0-13.47-.83-2.39-1.33-4-4.94-7.43-12.36-2.24-.72-2.9-1-3.44-3.13s.42-1.91,1.7-1.86C183.65,110.81,184.06,110.18,185.47,110.23Z"
      transform="translate(-157.9 -60.51)"
    />
    <path
      fill={fill}
      d="M184.06,114s-.58-1.11.08-1.19.94.63,1.32,1.83S184.67,115.71,184.06,114Z"
      transform="translate(-157.9 -60.51)"
    />
    <path
      fill={altFill}
      d="M246.74,110.54s-20.17-.18-22.75-.1-3.93,1.34-5.38,2.31a5.15,5.15,0,0,1-3.82.75l-.17,3.39s3.24-1.31,3.74,2.25,1.29,10.42,6.32,11c6.49.77,12,.13,13.42-.63,2.44-1.3,4.27-4.91,8.07-12.31,2.26-.7,2.94-1,3.61-3.11s-.29-1.92-1.57-1.88C248.52,111.15,248.14,110.51,246.74,110.54Z"
      transform="translate(-157.9 -60.51)"
    />
    <path
      fill={fill}
      d="M247.9,114.29s.65-1.11,0-1.19-1,.62-1.42,1.82S247.18,116.06,247.9,114.29Z"
      transform="translate(-157.9 -60.51)"
    />
    <path
      fill={fill}
      d="M191,112.35s10.81,0,14.84.5,5.64,1,6,4.26-.23,9.3-1.65,10.49-4,1.74-12.36,1.1c-4.58-.41-5-1.7-6.28-4.31s-3.06-7.83-3.39-8.79S187.88,112.58,191,112.35Z"
      transform="translate(-157.9 -60.51)"
    />
    <path
      fill={fill}
      d="M242,112.17s-10.7,0-14.69.5-5.57,1-5.94,4.22.23,9.2,1.64,10.38,4,1.72,12.24,1.09c4.53-.41,5-1.68,6.21-4.26s3.59-7.73,3.91-8.69S245,112.4,242,112.17Z"
      transform="translate(-157.9 -60.51)"
    />
    <path
      fill={altFill}
      d="M209.08,113s-6.84-.54-10-.67c-8.5-.33-10.5,4.84-9.33,8.17a47,47,0,0,0,3,7s-5.34-9-5.67-13.67c.17-2,2.17-2.66,6.17-2.5s10.5.34,10.5.34Z"
      transform="translate(-157.9 -60.51)"
    />
    <path
      fill={altFill}
      d="M235.08,112s-1,.17-4.5.33-9.67,5-9.17,9.84c-.16,1.16-2-4.67-2-6.34s3.08-3.68,6.21-3.84S235.08,112,235.08,112Z"
      transform="translate(-157.9 -60.51)"
    />
    <polygon fill={altFill} points="40.84 52.49 43.17 52.49 34.01 61.66 40.84 52.49" />
    <polygon fill={altFill} points="46.34 53.16 49.34 53.32 36.01 65.32 46.34 53.16" />
    <polygon fill={altFill} points="73.84 53.16 66.68 62.99 76.51 53.16 73.84 53.16" />
    <polygon fill={altFill} points="80.01 53.16 68.34 67.32 83.01 53.16 80.01 53.16" />
  </svg>
);

LogoBottom.propTypes = {
  size: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  fill: PropTypes.string.isRequired,
  altFill: PropTypes.string,
};

LogoBottom.defaultProps = {
  altFill: 'white',
};

export default LogoBottom;
